module.exports = __webpack_public_path__ + "img/home7.95e9d577.svg";